// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SocialShareModal-root-tnSM_ {
	padding: 20px 32px 32px 32px;
}

.SocialShareModal-container-uUWjw {
	margin: 0 auto;
	padding: 0px;
}

/** RentAll - Begin **/

.SocialShareModal-signupModalContainer-Zptma {
	max-width: 376px;
}

.SocialShareModal-signupModalBody-TXix1 {
	padding: 0px;
}

.SocialShareModal-formGroup-hC43X {
	margin-bottom: 6px;
}

.SocialShareModal-formSection-_S5G3 {
	overflow: hidden;
}

a,
a:hover,
a:focus,
a:active {
	color: var(--primary-link-foreground);
}

.SocialShareModal-captionText-I19ph {
	font-size: 16px;
	color: var(--primary-foreground);
	margin: 15px 0px;
}

.SocialShareModal-noPadding-cBBxw {
	padding: 0px;
}

.SocialShareModal-noMargin-IVj1y {
	margin: 0px;
}

.SocialShareModal-textAlignRight-uzvC7 {
	text-align: right;
}

.SocialShareModal-textAlignLeft-Tvo_v {
	text-align: left;
}

.SocialShareModal-textAlignCenter-cath8 {
	text-align: center;
}

.SocialShareModal-iconPosition-KDD15 {
	display: inline-block;
	margin: -2px 8px 0 0;
}

/** custom **/

.SocialShareModal-marginBottom24-v9qxF {
	margin-bottom: 24px !important;
}

.SocialShareModal-share-jnoiT {
	font-size: 24px !important;
	font-weight: 800 !important;
	padding-bottom: 10px;
}

.SocialShareModal-content-H6CTB {
	font-size: 16px !important;
}

.SocialShareModal-paddingbottom24-AeIde {
	padding-bottom: 24px;
	padding-top: 10px;
}

.SocialShareModal-socialIcons-X5vRU {
	color: var(--primary-foreground) !important;
	font-size: 24px !important;
	margin-right: 15px;
	display: inline-block;
}

.SocialShareModal-marginleftM5-JGvZB {
	margin-left: -5px;
}

.SocialShareModal-borderradiusNone-OgRz7 {
	border-radius: 0px !important;
}

.SocialShareModal-mainBorder-e0cAG {
	border-bottom: 1px solid var(--primary-border);
	margin-bottom: 18px;
}

@media screen and (max-width: 640px) {
	.SocialShareModal-smSpace-tqN5v {
		margin-bottom: 12px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/ViewListing/SocialShareModal/SocialShareModal.css"],"names":[],"mappings":"AAAA;CACC,4BAA4B;AAC7B;;AAEA;CACC,cAAc;CACd,YAAY;AACb;;AAEA,sBAAsB;;AACtB;CACC,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;;;CAIC,qCAAqC;AACtC;;AAEA;CACC,eAAe;CACf,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,oBAAoB;AACrB;;AAEA,aAAa;;AACb;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,oBAAoB;AACrB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,oBAAoB;CACpB,iBAAiB;AAClB;;AAEA;CACC,2CAA2C;CAC3C,0BAA0B;CAC1B,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8CAA8C;CAC9C,mBAAmB;AACpB;;AAEA;CACC;EACC,mBAAmB;CACpB;AACD","sourcesContent":[".root {\n\tpadding: 20px 32px 32px 32px;\n}\n\n.container {\n\tmargin: 0 auto;\n\tpadding: 0px;\n}\n\n/** RentAll - Begin **/\n.signupModalContainer {\n\tmax-width: 376px;\n}\n\n.signupModalBody {\n\tpadding: 0px;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.formSection {\n\toverflow: hidden;\n}\n\na,\na:hover,\na:focus,\na:active {\n\tcolor: var(--primary-link-foreground);\n}\n\n.captionText {\n\tfont-size: 16px;\n\tcolor: var(--primary-foreground);\n\tmargin: 15px 0px;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\n.textAlignRight {\n\ttext-align: right;\n}\n\n.textAlignLeft {\n\ttext-align: left;\n}\n\n.textAlignCenter {\n\ttext-align: center;\n}\n\n.iconPosition {\n\tdisplay: inline-block;\n\tmargin: -2px 8px 0 0;\n}\n\n/** custom **/\n.marginBottom24 {\n\tmargin-bottom: 24px !important;\n}\n\n.share {\n\tfont-size: 24px !important;\n\tfont-weight: 800 !important;\n\tpadding-bottom: 10px;\n}\n\n.content {\n\tfont-size: 16px !important;\n}\n\n.paddingbottom24 {\n\tpadding-bottom: 24px;\n\tpadding-top: 10px;\n}\n\n.socialIcons {\n\tcolor: var(--primary-foreground) !important;\n\tfont-size: 24px !important;\n\tmargin-right: 15px;\n\tdisplay: inline-block;\n}\n\n.marginleftM5 {\n\tmargin-left: -5px;\n}\n\n.borderradiusNone {\n\tborder-radius: 0px !important;\n}\n\n.mainBorder {\n\tborder-bottom: 1px solid var(--primary-border);\n\tmargin-bottom: 18px;\n}\n\n@media screen and (max-width: 640px) {\n\t.smSpace {\n\t\tmargin-bottom: 12px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SocialShareModal-root-tnSM_`,
	"container": `SocialShareModal-container-uUWjw`,
	"signupModalContainer": `SocialShareModal-signupModalContainer-Zptma`,
	"signupModalBody": `SocialShareModal-signupModalBody-TXix1`,
	"formGroup": `SocialShareModal-formGroup-hC43X`,
	"formSection": `SocialShareModal-formSection-_S5G3`,
	"captionText": `SocialShareModal-captionText-I19ph`,
	"noPadding": `SocialShareModal-noPadding-cBBxw`,
	"noMargin": `SocialShareModal-noMargin-IVj1y`,
	"textAlignRight": `SocialShareModal-textAlignRight-uzvC7`,
	"textAlignLeft": `SocialShareModal-textAlignLeft-Tvo_v`,
	"textAlignCenter": `SocialShareModal-textAlignCenter-cath8`,
	"iconPosition": `SocialShareModal-iconPosition-KDD15`,
	"marginBottom24": `SocialShareModal-marginBottom24-v9qxF`,
	"share": `SocialShareModal-share-jnoiT`,
	"content": `SocialShareModal-content-H6CTB`,
	"paddingbottom24": `SocialShareModal-paddingbottom24-AeIde`,
	"socialIcons": `SocialShareModal-socialIcons-X5vRU`,
	"marginleftM5": `SocialShareModal-marginleftM5-JGvZB`,
	"borderradiusNone": `SocialShareModal-borderradiusNone-OgRz7`,
	"mainBorder": `SocialShareModal-mainBorder-e0cAG`,
	"smSpace": `SocialShareModal-smSpace-tqN5v`
};
module.exports = ___CSS_LOADER_EXPORT___;
